import React, { useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { TAXONOMY_CODES, type TaxonomyCode } from '../../features/admin-settings/data/nuccTaxonomyCodes';

interface TaxonomyCodeFieldProps {
  value: string;
  onChange: (next: string) => void;
}

export default function TaxonomyCodeField({ value, onChange }: TaxonomyCodeFieldProps) {
  const selected = useMemo<TaxonomyCode | null>(() => {
    if (!value) return null;
    return TAXONOMY_CODES.find((c) => c.code === value) ?? null;
  }, [value]);

  return (
    <Autocomplete<TaxonomyCode, false, false, true>
      freeSolo
      options={TAXONOMY_CODES}
      groupBy={(option) => option.category}
      getOptionLabel={(option) =>
        typeof option === 'string' ? option : `${option.code} — ${option.label}`
      }
      isOptionEqualToValue={(option, val) =>
        typeof val === 'string' ? option.code === val : option.code === val.code
      }
      value={selected ?? value ?? ''}
      onChange={(_, next) => {
        if (!next) {
          onChange('');
        } else if (typeof next === 'string') {
          onChange(next.trim());
        } else {
          onChange(next.code);
        }
      }}
      onInputChange={(_, next, reason) => {
        if (reason === 'input') {
          onChange(next.trim());
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Taxonomy Code"
          margin="normal"
          placeholder="Search by discipline or paste a NUCC code"
          helperText="Provider taxonomy code for insurance claim submission. Type to search common mental-health codes, or paste any NUCC code."
        />
      )}
    />
  );
}
